import { Key } from '@/enums/key';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { local_ui_set_key_is_shift_pressed } from '@/state/ui/hotkeys/local_ui_set_key_is_shift_pressed';

export function WATCHER__key_shift() {
  const dispatch = use_dispatch();

  const { global__is_app_on_focus } = use_slice_ui(['global__is_app_on_focus']);

  /*
   * EFFECTS
   */
  use_effect(() => {
    if (global__is_app_on_focus) return;

    dispatch(local_ui_set_key_is_shift_pressed(false));
  }, [global__is_app_on_focus]);

  use_effect(() => {
    window.keydown_on(onKeyDown);
    window.addEventListener('keyup', onKeyUp);

    return () => {
      dispatch(local_ui_set_key_is_shift_pressed(false));

      window.keydown_off(onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  /*
   * EVENTS
   */
  function onKeyDown(e: KeyboardEvent) {
    if (e.key != Key.Shift) return;

    dispatch(local_ui_set_key_is_shift_pressed(true));
  }

  function onKeyUp(e: KeyboardEvent) {
    if (e.key != Key.Shift) return;

    dispatch(local_ui_set_key_is_shift_pressed(false));
  }

  return <></>;
}
